import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  footer: {
    backgroundColor: "#244776",
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "15px",
    margin: "40px 0 0 0"
  }
});

const Footer = () => (

  <View style={styles.footer} fixed>
  </View>
);

export default Footer